export const languages = [
  {
    language_id: "1",
    code: "en",
    label: "English",
    short: "EN",
  },
  {
    language_id: "2",
    code: "sw",
    label: "Swahili",
    short: "SW",
  },
];
export const countryCode = "255";

export const isValidUrl = (str) => {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
};
